import { render, staticRenderFns } from "./categoryStore.vue?vue&type=template&id=6abb1c62&scoped=true"
import script from "./categoryStore.vue?vue&type=script&lang=js"
export * from "./categoryStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb1c62",
  null
  
)

export default component.exports